import { IApplicationState } from '../../types/redux';

export const getIsAuthenticated = (state: IApplicationState) => {
  return state.user.isAuthenticated;
};
